
<template>
      <div class="car-ka car-con">
            <div class="car-large" :class="carno?'car-large-no':''">
                <div class="swiper-container">
                    <!-- <div class="swiper-wrapper"> -->
                        <swiper :options="swiperOption" class="swiper-wrapper" ref="mySwiper">
                                <swiper-slide class="swiper-slide" v-for="(item,index) in carddata" :key="index">
                                    <img class="pg" :src="'//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/card'+item.indexka+'.png'" />
                                    <div class="ann" v-if="item.indexka!='13'&&item.indexka!='14'&&item.indexka!='15'">
                                        <a data-stat="立即开奖" v-if="item.cardStatus==0" :data-cardNo="item.cardNo" class="lijiang" @click="takeBoxcha(item.cardNo,item.channel)" href="javascript:void(0);"></a>
                                        <a data-stat="查看奖励" class="lijiang da1" v-if="item.cardStatus==1" :href="juanlink"></a>
                                        <a v-if="ifylxd" data-stat="赠送卡片" class="zengs" @click="queryzhand(item.cardId)"  href="javascript:void(0);"></a>
                                    </div>
                                    <a data-stat="一分购" class="hcheng" :class="iftime?'jinru':''" v-if="item.indexka==15&&item.indexka!='13'" :href="yifenlink"></a>
                                    <a data-stat="锦鲤奖" class="jinlika" :class="iftime?'jinru':''" v-if="item.indexka==14&&item.indexka!='13'" :href="jinlilink"></a>
                                </swiper-slide>
                                <div class="swiper-slide js-carno" v-if="carno">
                                <img src="//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/card0.png">
                                </div>
                        </swiper>
                    <div data-stat="查看卡片_左" class="swiper-button-prev"></div>
                    <div data-stat="查看卡片_右" class="swiper-button-next"></div>
                   
                </div>
            </div>
            <div class="car-Smallbox" :class="classstay?'yans1':''">
                <div class="car-Small" >
                    <ul class="clearfix">
                    <li v-for="(item,index) in cardnolistmy" :key="index" :data-cad="index">
                        <a @click="choukato(item.taget)" :data-stat="'小卡_卡'+item.inde" :data-tagat="item.taget" href="javascript:void(0);" :class="item.status">
                            <img :src="'//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/car'+item.ifget+'_'+item.inde+'.png'" alt="">
                            <i v-if="item.totalNums>1">{{item.totalNums}}</i>
                        </a>
                    </li>
                </ul>
                </div>
                <div class="car-show"></div>
            </div>
            <div class="car-an">
                    <a ata-stat="合成卡片" v-if="synthesis" @click="combinationcard" class="hc" href="javascript:void(0);"></a>
                    <a data-stat="领取我的卡皮" v-if="activityTimes>0" @click="chouka" class="car-lin" href="javascript:void(0);"><span v-if="activityTimes>0">{{activityTimes}}</span></a>
                    <a v-if="activityTimes<=0" class="car-lin car-lin-no" href="javascript:void(0);"></a>
                </div>
        </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props:['carddata','carno','hchengka','synthesis','activityTimes','cardnolistmy','juanlink','yifenlink','jinliif','jinlilink','classstay','ifylxd'], 
  data () {
      return {
        swiperOption:{
        slidesPerView: 3,
        spaceBetween:-14,
        centeredSlides: true,
        initialSlide:0,
        loop: false,
        observer: true,
        observeSlideChildren:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        },
        iftime:false,
      }
    },
    created(){
        let m=this;
        this.HTTP.datetime().then((res) => { 
                let times=res.time;
                var statdata1=new Date().parse("2020-02-10 00:00:00").getTime();
                if(statdata1<times){
                    m.iftime=true;
                }
                console.log(times)
        },(ree) =>{

        });
        
        
    }, 
    computed:{
        swiper() {  
            return this.$refs.mySwiper.swiper;  
        } 
    },
    methods:{
          chouka(){
              this.$parent.getka();
          },
          takeBoxcha(activityCode,channelka){
              this.$parent.takeBox(activityCode,channelka);
          },
          combinationcard(){
              this.$parent.hccombine();
          },
          choukato(tagat){
            if(event.currentTarget.className=='over'){
                return;
            }else{
                 if(tagat>=0){
                    this.swiper.slideTo(tagat, 500, false);
                }
            }
          },
          queryzhand(cardId){
            let m=this;
            this.HTTP.queryYxdTeamhttp().then((res) => {
                if(res.body.returnCode=='0000'){
                    if(res.body.data){
                        this.$parent.qrygivefunct(cardId)
                    }else{
                        this.$parent.showclan()

                    }
                }
            }, (err) => {
                console.log(err);
            });
          }

    },
    mounted(){
         
    },
     components:{
      swiper,
      swiperSlide
    }
  
}
</script>

<style scoped>
.car-con{
    width: 100%;
    overflow: hidden;
    padding-bottom: .5rem;
}
.car-con .title{
    width: 100%;
    text-align: center;
}
.car-con .title img{
    height: .61rem;
    width:auto;
    display: inline-block;
}
/* 大卡展示 */
.car-large{
    display: block;
    width: 148%;
    height: 5.18rem;
    position: relative;
    -webkit-transform: translateX(-16.5%);
    -moz-transform: translateX(-16.5%);
    -ms-transform: translateX(-16.5%);
    -o-transform: translateX(-16.5%);
    transform: translateX(-16.5%);
    margin-top: .36rem;
}
.car-large .swiper-container{
    height: 100%;
    overflow: inherit;
}
.car-large .swiper-container .swiper-slide {
    text-align: center;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    transform: scale(0.8);
    border-radius: .18rem;
}
.car-large.car-large-no .swiper-container .swiper-slide{
    box-shadow: none;
}
.car-large .swiper-container .swiper-slide-active,.car-large .swiper-container .swiper-slide-duplicate-active {
    transform: scale(1);
    z-index: 2;
}
.car-large .swiper-container .swiper-slide-active:before,.car-large .swiper-container .swiper-slide-duplicate-active:before {
    content: '';
    width: 7.5rem;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 50%;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/bg6.png) no-repeat center .5rem;
    background-size: 7.5rem 4.8rem;
    transform: translateX(-50%);
    z-index: -1;
}
.car-large .swiper-button-next,.car-large .swiper-button-prev{
    width: .52rem;
    height: .48rem;
    background: url(//i1.ulecdn.com/i/event/2018/0511/card/cr.png) no-repeat center;
    background-size: 100% 100%;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-top: 0;
}
.car-large .swiper-button-prev,.car-large .swiper-container-rtl .swiper-button-next{
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/anl.png) no-repeat center;
    background-size: 100% 100%;
    left: 27%;
}
.car-large .swiper-button-next.swiper-button-disabled,.car-large .swiper-button-prev.swiper-button-disabled{
    opacity: 1;
}
.car-large .swiper-button-next,.car-large .swiper-container-rtl .swiper-button-prev{
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/anr.png) no-repeat center;
    background-size: 100% 100%;
    right:27%;
}
.car-large .swiper-slide .di1{
    display: block;
    top: 85%;
    width: 72%;
    height: .76rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an8.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
    position: absolute;
    left: 14%;
}
.swiper-button-next:after, .swiper-button-prev:after {
   display: none;
}
/* 卡片区域 */
.car-Small{
    display: block;
    width: 100%;
    box-sizing: border-box;  
    overflow-y: scroll;
    height: 100%;
    padding-top: 0.1rem;
}
.car-Smallbox{
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0rem .06rem;
    width: 93.33%;
    position: relative;
    padding-bottom: .1rem;
    height: auto;
    margin-top: .76rem;
    margin-bottom: 0.5rem;
}
.car-Smallbox.yans1{
    height: 4rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/i5.png) no-repeat center bottom;
    background-size: 100% .1rem;
}
.car-Smallbox.yans1::before{
    content: '';
    display: block;
    position: absolute;
    bottom: .05rem;
    left: 50%;
    width: 97%;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/i3.png) no-repeat center;
    background-size: 100% 100%;
    height: 0.4rem;
    transform: translateX(-50%);
    z-index: 2;
}
.car-Small ul{
    display: block;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
}
.car-Small ul li{
    width: 15.6%;
    float: left;
    margin-right: 1.4%;
    margin-bottom: 2.8%;
    position: relative;
    height: 1.3rem;
}
.car-Small ul.hcl li:nth-of-type(1),
.car-Small ul.jl1 li:nth-of-type(2),
.car-Small ul.wn1 li:nth-of-type(3)
{
    display: none;
}
.car-Small ul li a,.car-Small ul li a img{
    display: block;
    width: 100%;
}
.car-Small ul li a i{
    display: block;
    position: absolute;
    top: 0rem;
    right: 0rem;
    color: #A75D18;
    background-color: #FFC076;
    font-size: .2rem;
    border-radius: .14rem;
    padding: .01rem .07rem;
}
.car-Small ul li:nth-of-type(5),.car-Small ul li:nth-of-type(11){
    margin-right: 0;
}
.car-Small ul li:nth-of-type(6){
    float: right;
    margin-right: 0;
}
.car-Small ul li:nth-of-type(12){
    float: right;
    margin-right: 0;
}
.car-an{
    display: block;
    width: 100%;
    text-align: center;
}
.car-an .hc{
    display: inline-block;
    width: 41%;
    height: .76rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an1.png) no-repeat center;
    background-size: 100% 100%;
    margin-right: .05rem;
}
.car-lin{
    display:inline-block;
    width: 41%;
    height: .76rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an6.png) no-repeat center;
    background-size: 100% 100%;
    position: relative;
}
.car-lin.car-lin-no{
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an5.png) no-repeat center;
    background-size: 100% 100%;
}
/* .swiper-slide .zi, .swiper-slide .pai, .swiper-slide .pd, .swiper-slide .lijiang, .ka-conten .zi, .ka-conten .pai, .ka-conten .pd, .ka-conten .lijiang {
    height: auto;
    display: block;
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
} */
.swiper-slide .zi,.swiper-slide .pai,.swiper-slide .pd,.swiper-slide .hcheng,
.ka-conten .zi,.ka-conten .pai,.ka-conten .pd,.ka-conten .hcheng
{
    position: absolute;
    top: 82%;
    width: 80%;
    height: .64rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an10.png) no-repeat center;
    background-size:contain;
    z-index: 4;
    left: 10%;
    display: block;
}
.swiper-slide .hcheng.jinru{
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an14.png) no-repeat center;
    background-size:contain;
}
.jinlika{
    position: absolute;
    top: 82%;
    width: 80%;
    height: .64rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an9.png) no-repeat center;
    background-size: contain;
    z-index: 4;
    left: 10%;
    display: block;
}
.jinlika.jinru{
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an8.png) no-repeat center;
    background-size: contain;
}
.ann{
    display: block;
    top: 85%;
    width: 100%;
    height: .48rem;
    z-index: 4;
    position: absolute;
    text-align: center;
}
.swiper-slide .lijiang{
    display: inline-block;
    width: 1.56rem;
    height: 100%;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an12.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
}
.lijiang.da1{
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an11.png) no-repeat center;
    background-size: 100% 100%;
}
.zengs{
    display: inline-block;
    width: 1.56rem;
    height: 100%;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an13.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
}
.car-lin span {
    display: block;
    position: absolute;
    top: -.08rem;
    right: .06rem;
    color: #fef3a7;
    background-color: #e03c34;
    border: 1px solid #fff3a5;
    font-size: .2rem;
    border-radius: .14rem;
    padding: .01rem .07rem;
}
</style>



// WEBPACK FOOTER //
// src/components/commont/Carddisplay.vue